import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { reduxForm } from 'redux-form';

class BusRequestArchiveForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    render() {
        const { onSubmit, t } = this.props;

        return (
            <form className="form-horizontal" onSubmit={onSubmit}>
                <div className="col-12">{t('bus_requests.archive_info')}</div>
            </form>
        );
    }
}

export default reduxForm({
    form: 'busRequestArchiveForm',
})(BusRequestArchiveForm);
